import React, { FC } from 'react';

import './checkboxStyle.css';
import { CheckboxProps, FormGroup, FormControlLabel, Checkbox } from '@mui/material';

interface OwnProps {
  label?: any;
  value?: any;
  field?: string;
  textChange?: (value: boolean, field: string, error?: { error: boolean; message: string }) => void;
}

const CheckBox: FC<OwnProps & CheckboxProps> = ({ label, value, disabled, textChange, field, sx }) => {
  const handleChange = (event: { target: { checked: boolean } }) => {
    const value = event.target.checked;
    if (textChange) textChange(value, field as string, { error: false, message: '' });
  };

  return (
    <FormGroup sx={sx}>
      <FormControlLabel
        control={<Checkbox data-testid={'test'} disabled={disabled} checked={value} onChange={handleChange} />}
        label={label}
      />
    </FormGroup>
  );
};

export default CheckBox;
